import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLazyGetUserBadgesQuery } from "../../../store/api/userApi";

const Trophy = () => {
  const { user_id: userId } = useParams();
  const [badges, setBadges] = useState<any>([]);
  const [getBadges] = useLazyGetUserBadgesQuery({ userId });
  const fetchBadges = async () => {
    if (!userId) return;
    try {
      const response = await getBadges({ userId })?.unwrap();
      if (response?.success) {
        setBadges(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchBadges();
  }, [userId]);

  return (
    <div className="w-full bg-white rounded-lg p-4">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold">Trophy Case</h1>
      </div>
      <h2 className="text-[#999999] pb-2 pt-4">Academy Badges</h2>
      <div className="w-full overflow-x-auto">
        {badges.length > 0 ? (
          <div className="flex gap-6 p-2">
            {badges.map((badge: any) => (
              <img
                src={badge.badge_icon}
                alt="Badge Icon"
                className="w-16 h-16 rounded-lg"
              />
            ))}
          </div>
        ) : (
          <h4 className="text-[#999999]">No badges yet</h4>
        )}
      </div>
    </div>
  );
};

export default Trophy;
